<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,Pedestals & Posts"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>These pedestal-type posts are for 3/8" and ½" thick frameless interpretive signs that are mounted at a
          low-profile angle on top of one or more pedestal/posts. At the top of each pedestal/post is a mounting
          plate with holes for attaching the sign. A typical pedestal-type post is 3"x3"x60" long with a 12"
          mounting plate set at a 45-degree angle. When the post is set 24" in the ground, the center of the sign is
          three feet high. Most pedestal-type posts are powder-coated aluminum. Two or more pedestal/posts
          are suggested for signs larger than 30" wide. Anodized aluminum posts, painted posts, and steel posts
          are available. Custom sizes, lengths, and surface-mounts are also available.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img pedestals-113-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/frameless-sign-with-flush-mount-post.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img pedestals-80-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/low-profile-double-pedestal-with-frameless-sign.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img pedestals-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/low-profile-single-pedestal-with-custom-shaped-sign.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img pedestals-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/low-profile-single-pedestal-with-wood-frame.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img pedestals-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/low-profile-single-pedestal-with-frameless-sign.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img pedestals-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/pedestals/custom-concrete-pedestal.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Pedestals & Posts'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Pedestals.vue